import React, { useState, useEffect } from "react";
import {
  getServiceCity,
  getAirportData,
} from "../../Services/Shared.service";
import Context from "./index";
import { useController, useForm } from "react-hook-form";
import { getTaxGroupList } from "../../Services/Packages.service";
const SharedDataProvider = (props) => {
  const[tabValue,setTabValue] = useState(0);
  const [allCityData, setAllCityData] = useState([]);
  const [cityData, setCityData] = useState([]);
  const [airportData, setAirportData] = useState([]);
  const [showApiLoader, setShowApiLoader] = useState(false);
  const [pageNumber, setPageNumber] = useState(0);
  const [isRefresh,setIsRefresh] = useState(false);
  const [taxData,setTaxData] = useState([]);
  const [packageTable,setPackageTable] = useState(false)
  const [dateFilter, setDateFilter] = useState({
    startDate: new Date(),
    endDate: new Date(),
    label: "Today"
  })

  const trgiggerRefresh = ()=>{
    setIsRefresh((prev) => !prev);
  }
  const [corpRefresh,setCorpRefresh] = useState(false)
  const[tabTariff,setTabTariff] = useState(0)
  const { control } = useForm();
  const globalCityField = useController({
    name: "globalCityFilter",
    control,
  }).field;
  useEffect(() => {
    getServiceCity().then((result) => {
      if (result.status == 200 && result.data.length > 0) {
        setAllCityData(result.data);
        let data = [];
        result.data.forEach((element) => {
          if (element?.isDeleted == false) {
            data.push({
              value: element,
              label: element.name,
              id: element.id,
            });
          }
        });
        setCityData(data);
      }
    });

    getAirportData().then((result) => {
      if (result.status == 200 && result.data.length > 0) {
        setAirportData(result.data);
      }
    });
  }, []);

  useEffect(() => {
    fetchServiceCity();
  }, [isRefresh]);

  const fetchServiceCity=()=>{
    getServiceCity().then((result) => {
      if (result.status == 200 && result.data.length > 0) {
        setAllCityData(result.data);
        let data = [];
        result.data.forEach((element) => {
          if (element?.isDeleted == false) {
            data.push({
              value: element,
              label: element.name,
              id: element.id,
            });
          }
        });
        setCityData(data);
      }
    });

    getAirportData().then((result) => {
      if (result.status == 200 && result.data.length > 0) {
        setAirportData(result.data);
      }
    });
  }

  console.log("date filter values", dateFilter)

  return (
    <Context.Provider
      value={{
        ...props,
        allCityData,
        cityData,
        airportData,
        globalCityField: globalCityField,
        showApiLoader,
        setShowApiLoader: setShowApiLoader,
        pageNumber,
        setPageNumber,
        dateFilter,
        setDateFilter,
        tabValue,
        setTabValue,
        isRefresh,
        trgiggerRefresh,
        corpRefresh,
        setCorpRefresh,
        tabTariff,setTabTariff,
        taxData,packageTable,setPackageTable
      }}
    >
      {props.children}
    </Context.Provider>
  );
};

export default SharedDataProvider;
